module.exports = __webpack_public_path__ + "img/lead-11z.1c6f1b03.png";